import { render, staticRenderFns } from "./workcenter-card.vue?vue&type=template&id=591d2818"
import script from "./workcenter-card.vue?vue&type=script&lang=js"
export * from "./workcenter-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports